/**
* Abstract View Model that serves as a basis for other derived View Models
* and provides common functionality across all View Models
*
* @class AbstractViewModel
*/
var AbstractViewModel = function (parent) {
  var self = this;

  self.parent = parent;

	/**
	* This method searches the browser's URL for the query string for a
	* key=value pair with the provided key. If found, returns the value
	*
	* @method getQueryParam
	* @param {String} sName Key name to find the value for
	* @return {String} Returns the string value corresponding to the key or false
	*/
  self.getQueryParam = function (sName) {
    var match = new RegExp('[?&]' + sName + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  };


	/**
	* This method creates a subscription (observable) in a ViewModel that
	* is derived from a KnockoutJS observable variable contained in another
	* object.
	*
	* @method dependentObservable
	* @param {String} sParamName The name of the observable value to subscribe to
	* @param {Object} oDependentObject An object containing the observable
	* @return {ObservedVariable} Returns a reference to the observed variable
	*                            contained by the dependent object
	*/
  self.dependentObservable = function (sParamName, oDependentObject) {
    return ko.computed(function () {
      return oDependentObject[sParamName]();
    });
  };


	/**
	* Converts the provided val to a Boolean, or Null
	*
	* @method parseBoolean
	* @param {Mixed} val
	* @returns {Boolean | Null}
	*/
  self.parseBoolean = function (val) {
    if (val === true || (typeof val == 'string' && val.toLowerCase() == 'true')) {
      return true;
    }
    else if (val === false || (typeof val == 'string' && val.toLowerCase() == 'false')) {
      return false;
    }

    return null;
  };


  /**
  * Interprets a value and converts it to Boolean, Number or String based on content
  *
  * @method parseValue
  * @param {Mixed} val
  * @return {Mixed}
  */
  this.parseValue = function (val) {
    // Create a numeric value from the passed parameter
    var num = Number(val);

    // If the value is 'true' or 'false', parse it as a Boolean and return it
    if (val.toLowerCase() === 'true' || val.toLowerCase() === 'false') {
      return (val.toLowerCase() == 'true') ? true : false;
    }

    // If the num parsed to a Number, return the numeric value
    // Else if the valuse passed has no length (an attribute without value) return null,
    // Else return the param as is
    return (isNaN(num)) ? val : (val.length == 0) ? null : num;
  };

};

if (typeof exports !== 'undefined') {
  exports.AbstractViewModel = AbstractViewModel;
}
